import React, { Suspense } from 'react';
import { Loading } from '@fides/fides-react-components';

const Logout = React.lazy(() => import('../../components/pages/Logout'));

export const LogoutRouter = () => (
  <Suspense fallback={<Loading />}>
    <Logout />
  </Suspense>
);
